import React from "react";
import { useLocation, useParams } from "react-router-dom";
import ChatPage from "./ChatPage";

const ProjectChatPage = () => {
  const { projectId } = useParams();
  const location = useLocation();
  const projectState = location.state || {};

  return (
    <ChatPage
      projectId={projectId}
      firstMessage={projectState.firstMessage}
      attachedFilesFromHome={projectState.attachedFilesFromHome}
    />
  );
};

export default ProjectChatPage;
